import Drawable from '../entities/Drawable.js';
import { spriteStore } from '../images.js';
export default class BattleMenu extends Drawable {
    constructor({
        sprites = { battleOptionsBox: spriteStore.store.battleOptionsBox },
        position = { x: 120, y: 112 },
        visible = false,
    }) {
        super();
        this.sprites = sprites;
        this.position = position;
        this.option = 0;
        this.visible = visible;
    }

    draw() {
        if (!this.visible) {
            return;
        }
        this.sprites.battleOptionsBox.frames.val = this.option;
        this.sprites.battleOptionsBox.draw();
    }
}
